import React from 'react';

type ReceiptRowV3Props = {
    value?: string | React.JSX.Element | Function,
    subvalue?: string | React.JSX.Element | Function,
    classes?: string[]
}

const ReceiptRowV3 = (props: ReceiptRowV3Props) => {

    let classes = ['receipt-row-v3'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    const renderValue = (): string | React.JSX.Element => {
        if (props.value === undefined) {
            return <></>;
        }

        return (
            <div className="receipt-row-v3__value">
                {(typeof props.value === 'function') ? props.value() : props.value}
            </div>
        );
    }

    const renderSubvalue = (): string | React.JSX.Element => {
        if (props.subvalue === undefined) {
            return <></>;
        }

        return (
            <div className="receipt-row-v3__subvalue">
                {(typeof props.subvalue === 'function') ? props.subvalue() : props.subvalue}
            </div>
        );
    }

    return (
        <div className={classes.join(' ')}>
            {renderValue()}
            {renderSubvalue()}
        </div>
    );

}

export default ReceiptRowV3;